import { Authorization } from '@/constants/authorization';
import authorizationUtil from '@/utils/authorization-util';
import request from '../../utils/request';
export interface userLogin {
  mobile?: string | undefined;
  email?: string | undefined;
  password?: string | undefined;
  mobile_or_email?: string | undefined;
  captcha?: string;
  login_type: 'email' | 'mobile';
  login_type_key: 'captcha' | 'password';
}
interface resetPass {
  mobile: string;
  mobile_captcha: string;
  password: string;
  confirm_password: string;
}
export type LoginResponse = {
  'access-token': string;
};
export const getPartnerToken = () => {
  return {
    [Authorization]: authorizationUtil.getPartnerAuthorization(),
  };
};

//  获取 账号信息
export const getPartnerAccountInfo = () => {
  return request.get('/v1/partner/account/info', {
    headers: getPartnerToken(),
  });
};

//  提交  注册接口
export const storePartnerRegister = (option: { [key: string]: any }) => {
  return request.post('/v1/partner/account/register', { data: option });
};
//  提交  登录接口
export const storePartnerLogin = (option: userLogin) => {
  return request.post('/v1/partner/account/login', { data: option });
};

//  提交  公司信息完善
export const savePartnerCompany = (option: {
  company_type: string;
  from_data: any;
}) => {
  return request.post('/v1/partner/company/save', {
    data: option,
    headers: getPartnerToken(),
  });
};

//  提交  重置密码
export const partnerResetPassword = (option: resetPass) => {
  return request.post('/v1/partner/account/reset/password', { data: option });
};

//  合作伙伴工作台-合作意向列表
export const queryPartnerCluesList = (option: any) => {
  return request.post('/v1/clues/partner/list', {
    data: option,
    headers: getPartnerToken(),
  });
};

//  合作伙伴工作台-合作意向消息详情
export const queryPartnerCluesMssageList = (option: any) => {
  return request.post('/v1/clues/message/list', {
    data: option,
    headers: getPartnerToken(),
  });
};

//  合作伙伴工作台-合作意向消息 标记已读
export const readPartnerCluesMessage = (option: any) => {
  return request.post('/v1/clues/read/message', {
    data: option,
    headers: getPartnerToken(),
  });
};

//  合作伙伴工作台-合作意向消息  合作伙伴 回复
export const replyPartnerCluesMessage = (option: {
  thread_id: string;
  reply_to_id: string;
  content: string;
}) => {
  return request.post('/v1/clues/partner/reply', {
    data: option,
    headers: getPartnerToken(),
  });
};
